import { CommonModal } from 'components';
import React from 'react';
import './tripInfoModal.css';

const TripInfoModal = (props) => {
  const propsTripInfoModal = {
    ...props,
  }

  return (
    <>
      <CommonModal {...propsTripInfoModal}>

        <div className="__suplierMsg_bxs">
          <div className="accordion" id="tripAccordionExample">

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <span>Message to Supplier</span>
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#tripAccordionExample"
              >
                <div className="accordion-body">
                  <div className="__tprInfo_bxs">
                    <p>
                      Dear Supplier Name, <br />
                      Vimla Enterprises hired Vehicle Number{" "}
                      <span className="_semiBold">MP20GA2109</span> for trip from{" "}
                      <span className="_semiBold">Banglore to Delhi.</span> Total Freight{" "}
                      <span className="_semiBold">Rs. 5,000</span> <br />
                      Date <span className="_semiBold">13 Aug 2025</span> <br />
                      <a href="https://Transport360.in">
                        Check details: https://Transport360.in
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  <span>Message to Party</span>
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#tripAccordionExample"
              >
                <div className="accordion-body">
                  <div className="__tprInfo_bxs">
                    <p>
                      Dear Supplier Name, <br />
                      Vimla Enterprises hired Vehicle Number{" "}
                      <span className="_semiBold">MP20GA2109</span> for trip from{" "}
                      <span className="_semiBold">Banglore to Delhi.</span> Total Freight{" "}
                      <span className="_semiBold">Rs. 5,000</span> <br />
                      Date <span className="_semiBold">13 Aug 2025</span> <br />
                      <a href="https://Transport360.in">
                        Check details: https://Transport360.in
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  <span>Message to Consignee</span>
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#tripAccordionExample"
              >
                <div className="accordion-body">
                  <div className="__tprInfo_bxs">
                    <p>
                      Dear Supplier Name, <br />
                      Vimla Enterprises hired Vehicle Number{" "}
                      <span className="_semiBold">MP20GA2109</span> for trip from{" "}
                      <span className="_semiBold">Banglore to Delhi.</span> Total Freight{" "}
                      <span className="_semiBold">Rs. 5,000</span> <br />
                      Date <span className="_semiBold">13 Aug 2025</span> <br />
                      <a href="https://Transport360.in">
                        Check details: https://Transport360.in
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </CommonModal>
    </>
  )
}

export default TripInfoModal